"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ScrollTop() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      // Prevent the browser from restoring the previous scroll on reload
      window.history.scrollRestoration = "manual";
    }
  }, []);

  // Start every page at the top, on first load and on each client-side
  // navigation. "instant" bypasses the html { scroll-behavior: smooth } rule,
  // which otherwise leaves the new page at the old scroll offset.
  // Hash links (e.g. /platform#dashboard) keep their anchor behavior.
  useEffect(() => {
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
